export class MonthlyPricing {
  teamBusinessPlan: string = '84';
  soloBusinessPlan: string = '50';
  teamProfessionalPlan: string = '44';
  soloProfessionalPlan: string = '28';
  teamBusinessAddOns: string = '28.50';
  teamProfessionalAddOns: string = '17';
}
